var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDirections(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OnLight/Button/Medium/Icon-only/Primary/Default-Copy-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LUI-icon-pd-directions-solid-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0,
    fill: "#D8D8D8",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6329883,10.8463634 L11.2034359,12.9895824 C10.9414992,13.1712753 10.6003696,13.1926528 10.3177941,13.0450829 C10.0352186,12.897513 9.85786062,12.6053648 9.85733659,12.2866066 L9.85733659,11.429319 L9.42864254,11.429319 C8.2448366,11.429319 7.28517227,12.3888708 7.28517227,13.572538 L7.28517227,14.0011818 L4.71300795,14.0011818 L4.71300795,7.14288106 L3.85561984,7.14288106 C3.53682426,7.1423571 3.24464178,6.96501989 3.09705457,6.68247751 C2.94946736,6.39993514 2.97084743,6.0588456 3.1525616,5.79693955 L5.29603186,2.36778921 C5.45639879,2.1380655 5.71890641,2.00118176 5.99909011,2.00118176 C6.27927382,2.00118176 6.54178143,2.1380655 6.70214836,2.36778921 L8.84561863,5.79693955 C9.02733279,6.0588456 9.04871286,6.39993514 8.90112565,6.68247751 C8.75353844,6.96501989 8.46135597,7.1423571 8.14256038,7.14288106 L7.28517227,7.14288106 L7.28517227,9.38040167 C7.94707643,9.03592285 8.68244571,8.85651378 9.42864254,8.85745624 L9.85733659,8.85745624 L9.85733659,8.00016865 C9.85786062,7.68141044 10.0352186,7.38926222 10.3177941,7.24169231 C10.6003696,7.09412241 10.9414992,7.11549997 11.2034359,7.29719283 L14.6329883,9.4404118 C14.862739,9.60075993 14.9996388,9.86323676 14.9996388,10.1433876 C14.9996388,10.4235385 14.862739,10.6860153 14.6329883,10.8463634 Z",
    id: "---\\u21B3-\\uD83C\\uDF08-Color",
    fillOpacity: 0.8,
    fill: "#000A19"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirections);
export default __webpack_public_path__ + "static/media/directions.e39e7ea94c198b30e737c25b3698c0c6.svg";
export { ForwardRef as ReactComponent };